import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { getWoodRecieve, getReport, getReportdashbaod, GetReport04Daily, GetReport05Daily } from "../../services/dashboard";
import BranchContext from "./../context/branch";
import Chart from "./../dashboard/chart";
import Chartdaily from "./chartdaily";
import numberWithCommas from "../common/number";
import Chartdiagram from "./../dashboard/chartdiagram"




const Dashboard = () => {
  const { currentBranch } = useContext(BranchContext);
  const [startDate, setStartDate] = useState(new Date());


  const [dateChart1, setdateChart1] = useState(new Date());
  const [dateChart2, setdateChart2] = useState(new Date());

  const [dateEndChart3, setdateEndChart3] = useState(new Date());
  const [dateEndChart4, setdateEndChart4] = useState(new Date());
  const [dateEndChart7, setdateEndChart7] = useState(new Date());
  const [dateEndChart8, setdateEndChart8] = useState(new Date());
  const [dateStartChart3, setdateStartChart3] = useState(new Date());





  const [dateChart4, setdateChart4] = useState(new Date());
  const [dateChart5, setdateChart5] = useState(new Date());
  const [dateChart6, setdateChart6] = useState(new Date());
  const [dateChart7, setdateChart7] = useState(new Date());
  const [dateChart8, setdateChart8] = useState(new Date());

  const [logdata, setlogdata] = useState([]);
  const [datachart1, setdatachart1] = useState([]);
  const [datachart2, setdatachart2] = useState([]);
  const [datachart3, setdatachart3] = useState([]);
  const [datachart4, setdatachart4] = useState([]);
  const [datachart5, setdatachart5] = useState([]);
  const [datachart6, setdatachart6] = useState([]);
  const [datachart7, setdatachart7] = useState([]);
  const [datachart8, setdatachart8] = useState([]);
  const [chipdata, setchipdata] = useState([]);

  const [chart1, setchart1] = useState({});
  const [chart2, setchart2] = useState({});
  const [chart3, setchart3] = useState({});
  const [chart4, setchart4] = useState({});
  const [chart5, setchart5] = useState({});
  const [chart6, setchart6] = useState({});
  const [chart7, setchart7] = useState({});
  const [chart8, setchart8] = useState({});
  // console.log("chart3",chart3)

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getWoodRecieve(
        "log",
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      );
      if (result) {
        setlogdata(result);
      }
    };
    loadData();
  }, [startDate, currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getWoodRecieve(
        "chip",
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      );
      if (result) {
        setchipdata(result);
      }
    };
    loadData();
  }, [startDate, currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getReport(
        "R04",
        moment(dateChart1, "YYYY-MM-DD").format("YYYY-MM-DD"), 1
      );
      if (result) {
        setdatachart1(result);
      }
    };
    loadData();
  }, [dateChart1, currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getReport(
        "R04",
        moment(dateChart2, "YYYY-MM-DD").format("YYYY-MM-DD"), 4
      );
      if (result) {
        setdatachart2(result);
      }
    };
    loadData();
  }, [dateChart2, currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await GetReport04Daily(
        moment(dateStartChart3, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(dateEndChart3, "YYYY-MM-DD").format("YYYY-MM-DD"), 1
      );
      if (result) {
        setdatachart3(result);
      }
    };
    loadData();
  }, [dateStartChart3, currentBranch, dateEndChart3]);
  // console.log(datachart3)

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await GetReport04Daily(
        moment(dateChart4, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(dateEndChart4, "YYYY-MM-DD").format("YYYY-MM-DD"), 4
      );
      if (result) {
        setdatachart4(result);
      }
    };
    loadData();
  }, [dateChart4, currentBranch, dateEndChart4]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getReportdashbaod(
        "R05",
        moment(dateChart5, "YYYY-MM-DD").format("YYYY-MM-DD"), 1
      );
      if (result) {
        setdatachart5(result);
      }
    };
    loadData();
  }, [dateChart5, currentBranch]);
  // console.log(datachart5)
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await getReportdashbaod(
        "R05",
        moment(dateChart6, "YYYY-MM-DD").format("YYYY-MM-DD"), 4
      );
      if (result) {
        setdatachart6(result);
      }
    };
    loadData();
  }, [dateChart6, currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await GetReport05Daily(
        moment(dateChart7, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(dateEndChart7, "YYYY-MM-DD").format("YYYY-MM-DD"), 1
      );
      if (result) {
        setdatachart7(result);
        // console.log('return api 7',result)
      }
    };
    loadData();
  }, [dateChart7, dateEndChart7, currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id !== "501") return;
    const loadData = async () => {
      const { data: result } = await GetReport05Daily(
        moment(dateChart8, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(dateEndChart8, "YYYY-MM-DD").format("YYYY-MM-DD"), 4
      );
      if (result) {
        // console.log('return api 8',result)
        setdatachart8(result);
      }
    };
    loadData();
  }, [dateChart8, dateEndChart8, currentBranch]);


  useEffect(() => {
    if (!datachart1 || !currentBranch) return;
    if (datachart1.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let categorie = [];

      var names = Object.keys(datachart1[0]);
      var header1 = names;
      var header2 = names;
      var header3 = names;
      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)
      for (const dataObj of datachart1) {
        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);
        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);
      }
      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },

        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },

        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value;
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },

        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart1(data)
    };
    chart();
  }, [datachart1, currentBranch]);

  useEffect(() => {
    if (!datachart2 || !currentBranch) return;
    if (datachart2.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];

      let categorie = [];

      var names = Object.keys(datachart2[0]);

      var header1 = names;
      var header2 = names;
      var header3 = names;

      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)



      for (const dataObj of datachart2) {

        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);

        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);

      }


      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },

        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },
        // colors: ["#FFAB2D", "#00ADA3", "#71B945"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value;
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },
        // series: myArray,
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart2(data)
    };
    chart();
  }, [datachart2, currentBranch]);

  useEffect(() => {
    if (!datachart3 || !currentBranch) return;
    if (datachart3.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let categorie = [];
      var names = Object.keys(datachart3[0]);
      var header1 = names;
      var header2 = names;
      var header3 = names;
      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)

      for (const dataObj of datachart3) {

        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);
        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);
      }
      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },

        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },

        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value;
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },

        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart3(data)
    };
    chart();
  }, [datachart3, currentBranch]);

  useEffect(() => {
    if (!datachart4 || !currentBranch) return;
    if (datachart4.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let categorie = [];
      var names = Object.keys(datachart4[0]);
      var header1 = names;
      var header2 = names;
      var header3 = names;
      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)

      for (const dataObj of datachart4) {

        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);
        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);
      }
      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },

        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },

        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value;
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },

        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart4(data)
    };
    chart();
  }, [datachart4, currentBranch]);

  useEffect(() => {
    if (!datachart5 || !currentBranch) return;
    if (datachart5.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      let data5 = [];

      let categorie = [];

      var names = Object.keys(datachart5[0]);
      // names = names.splice(0,1)
      var header1 = names;
      var header2 = names;
      var header3 = names;
      var header4 = names;
      var header5 = names;

      // var myArray = names.splice(0,1)
      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)
      header4 = header4.splice(1, 1)
      header5 = header5.splice(1, 1)



      for (const dataObj of datachart5) {

        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);
        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);
        data4.push(dataObj[Object.keys(dataObj)[4]]);
        data5.push(dataObj[Object.keys(dataObj)[5]]);

      }


      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },
          {
            name: header4,
            data: data4,
          },
          {
            name: header5,
            data: data5,
          },

        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },
        // colors: ["#FF0000", "#FF8000", "#333FF","#FF8000", "#333FF"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value;
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },
        // series: myArray,
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart5(data)
    };
    chart();
  }, [datachart5, currentBranch]);


  useEffect(() => {
    if (!datachart6 || !currentBranch) return;
    if (datachart6.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      let data5 = [];

      let categorie = [];

      var names = Object.keys(datachart6[0]);
      // names = names.splice(0,1)
      var header1 = names;
      var header2 = names;
      var header3 = names;
      var header4 = names;
      var header5 = names;

      // var myArray = names.splice(0,1)
      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)
      header4 = header4.splice(1, 1)
      header5 = header5.splice(1, 1)



      for (const dataObj of datachart6) {

        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);
        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);
        data4.push(dataObj[Object.keys(dataObj)[4]]);
        data5.push(dataObj[Object.keys(dataObj)[5]]);

      }


      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },
          {
            name: header4,
            data: data4,
          },
          {
            name: header5,
            data: data5,
          },

        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },
        // colors: ["#FF0000", "#FF8000", "#333FF","#FF8000", "#333FF"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value;
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },
        // series: myArray,
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart6(data)
    };
    chart();
  }, [datachart6, currentBranch]);

  useEffect(() => {
    if (!datachart7 || !currentBranch) return;
    if (datachart7.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      let data5 = [];

      let categorie = [];

      var names = Object.keys(datachart7[0]);
      // names = names.splice(0,1)
      var header1 = names;
      var header2 = names;
      var header3 = names;
      var header4 = names;
      var header5 = names;

      // var myArray = names.splice(0,1)
      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)
      header4 = header4.splice(1, 1)
      header5 = header5.splice(1, 1)



      for (const dataObj of datachart7) {

        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);
        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);
        data4.push(dataObj[Object.keys(dataObj)[4]]);
        data5.push(dataObj[Object.keys(dataObj)[5]]);

      }
      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },
          {
            name: header4,
            data: data4,
          },
          {
            name: header5,
            data: data5,
          },

        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },
        // colors: ["#FFAB2D", "#00ADA3", "#71B945"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value + " T";
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },
        // series: myArray,
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart7(data)
    };
    chart();
  }, [datachart7, currentBranch]);

  useEffect(() => {
    if (!datachart8 || !currentBranch) return;
    if (datachart8.length === 0) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      let data5 = [];
      let categorie = [];
      var names = Object.keys(datachart8[0]);
      var header1 = names;
      var header2 = names;
      var header3 = names;
      var header4 = names;
      var header5 = names;
      header1 = header1.splice(1, 1)
      header2 = header2.splice(1, 1)
      header3 = header3.splice(1, 1)
      header4 = header4.splice(1, 1)
      header5 = header5.splice(1, 1)
      for (const dataObj of datachart8) {

        categorie.push(dataObj.Time);
        data1.push(dataObj[Object.keys(dataObj)[1]]);
        data2.push(dataObj[Object.keys(dataObj)[2]]);
        data3.push(dataObj[Object.keys(dataObj)[3]]);
        data4.push(dataObj[Object.keys(dataObj)[4]]);
        data5.push(dataObj[Object.keys(dataObj)[5]]);
      }
      const data = {
        series: [
          {
            name: header1,
            data: data1,
          },
          {
            name: header2,
            data: data2,
          },
          {
            name: header3,
            data: data3,
          },
          {
            name: header4,
            data: data4,
          },
          {
            name: header5,
            data: data5,
          },
        ],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false,
          },
        },

        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        legend: {
          show: true,
          position: 'top',
          labels: {
            colors: "#B5B5C3",
            useSeriesColors: false
          },
        },
        grid: {
          show: false,
          strokeDashArray: 6,
          borderColor: "#dadada",
        },
        yaxis: {
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "15px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
            formatter: function (value) {
              return value;
            },
          },
        },
        xaxis: {
          categories: categorie,
          labels: {
            style: {
              colors: "#B5B5C3",
              fontSize: "12px",
              fontFamily: "Poppins",
              fontWeight: 400,
            },
          },
        },
        fill: {
          type: "solid",
          opacity: 3,
        },

        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      };
      setchart8(data)
    };
    chart();
  }, [datachart8, currentBranch]);


  const handleChangChartDate1 = (date) => {
    setdateChart1(date);
  }
  const handleChangChartDate2 = (date) => {
    setdateChart2(date);
  }
  const handleChangChartStartDate3 = (date) => {
    setdateStartChart3(date);
  }
  const handleChangChartEndDate3 = (date) => {
    setdateEndChart3(date);
  }
  const handleChangChartEndDate4 = (date) => {
    setdateEndChart4(date);
  }
  const handleChangChartEndDate7 = (date) => {
    setdateEndChart7(date);
  }
  const handleChangChartEndDate8 = (date) => {
    setdateEndChart8(date);
  }



  const handleChangChartDate4 = (date) => {
    setdateChart4(date);
  }
  const handleChangChartDate5 = (date) => {
    setdateChart5(date);
  }
  const handleChangChartDate6 = (date) => {
    setdateChart6(date);
  }
  const handleChangChartDate7 = (date) => {
    setdateChart7(date);
  }
  const handleChangChartDate8 = (date) => {
    setdateChart8(date);
  }

  if (!currentBranch) {
    return <></>;
  }
  if (currentBranch._id !== "501") {
    return <></>;
  }
  return (
    <div className="container-fluid">
      <div className="card-body p-0">
        <div className="row justify-content-center mb-2">
          <div className="col-sm-3 col-xs-12 ">
            <div className="m-2">
              <span>
                ข้อมูล ณ.วันที่ <span className="label"></span>
              </span>
              <div className="mt-2">
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-between mt-5  ">
        {logdata &&
          logdata.length > 0 &&
          logdata.map((item, index) => {
            return (
              <div
                className="col-xl-2 col-sm-3 "
                key={index}
                style={{ cursor: "pointer" }}
              >
                <div className="card card-coin ">
                  <div className="card-body text-center">
                    <div className="position-absolute top-0 start-50 translate-middle">
                      <span className="badge rounded-pill bg-warning text-dark">
                        <p className="mb-0 fs-14 mx-2">
                          <span className="mb-2 font-w900 ">
                            {numberWithCommas(item.values)} (T)
                          </span>
                        </p>
                      </span>
                    </div>

                    <h5 className="text-black mb-2 font-w600 my-4">
                      {item.name}
                    </h5>
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      <div className="row justify-content-between mt-5  ">
        {chipdata &&
          chipdata.length > 0 &&
          chipdata.map((item, index) => {
            return (
              <div
                className="col-xl-2 col-sm-3 "
                style={{ cursor: "pointer" }}
                key={index}
              >
                <div className="card card-coin">
                  <div className="card-body text-center">
                    <div className="position-absolute top-0 start-50 translate-middle">
                      <span className="badge rounded-pill bg-primary">
                        <p className="mb-0 fs-14 mx-2">
                          <span className="mb-2 font-w900">
                            {numberWithCommas(item.values)} (GT)
                          </span>
                        </p>
                      </span>
                    </div>
                    <h5 className="text-black mb-2 font-w600 mt-3">
                      {item.name}
                    </h5>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {chart1.series !== undefined && (
        <Chart
          data={chart1}
          header={"1.แหล่งที่มาไม้ท่อนและไม้สับรายชั่วโมง % (ST1)"}
          startDate={dateChart1}
          handleChangStartDate={handleChangChartDate1}
        />)}
      {chart2.series !== undefined && (
        <Chart
          data={chart2}
          header={"2.แหล่งที่มาไม้ท่อนและไม้สับรายชั่วโมง % (ST2)"}
          startDate={dateChart2}
          handleChangStartDate={handleChangChartDate2}
        />)}
      {chart3.series !== undefined && (
        <Chartdaily
          data={chart3}
          labels={"เริ่ม"}
          labels2={"ถึง"}
          header={"3.แหล่งที่มาไม้ท่อนและไม้สับรายวัน % (ST1)"}
          startDate={dateStartChart3}
          endDate={dateEndChart3}
          handleChangStartDate={handleChangChartStartDate3}
          handleChangEndDate={handleChangChartEndDate3}
        />)}
      {chart4.series !== undefined && (
        <Chartdaily
          data={chart4}
          labels={"เริ่ม"}
          labels2={"ถึง"}
          header={"4.แหล่งที่มาไม้ท่อนและไม้สับรายวัน % (ST2)"}
          startDate={dateChart4}
          endDate={dateEndChart4}
          handleChangStartDate={handleChangChartDate4}
          handleChangEndDate={handleChangChartEndDate4}
        />)}
      {chart5.series !== undefined && (
        <Chart
          data={chart5}
          header={"5.สายพันธุ์ไม้รายชั่วโมง % (ST1)"}
          startDate={dateChart5}
          handleChangStartDate={handleChangChartDate5}
        />)}
      {chart6.series !== undefined && (
        <Chart
          data={chart6}
          header={"6.สายพันธุ์ไม้รายชั่วโมง  % (ST2)"}
          startDate={dateChart6}
          handleChangStartDate={handleChangChartDate6}
        />)}
      {chart7.series !== undefined && (
        <Chartdaily
          data={chart7}
          labels={"เริ่ม"}
          labels2={"ถึง"}
          header={"7.สายพันธุ์ไม้รายวัน  % (ST1)"}
          startDate={dateChart7}
          endDate={dateEndChart7}
          handleChangStartDate={handleChangChartDate7}
          handleChangEndDate={handleChangChartEndDate7}
        />)}
      {chart8.series !== undefined && (
        <Chartdaily
          data={chart8}
          labels={"เริ่ม"}
          labels2={"ถึง"}
          header={"8.สายพันธุ์ไม้รายวัน  % (ST2)"}
          startDate={dateChart8}
          handleChangStartDate={handleChangChartDate8}
          endDate={dateEndChart8}
          handleChangEndDate={handleChangChartEndDate8}
        />)}



      {/* <Chartdiagram/> */}
    </div>
  );
};

export default Dashboard;
